import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";

import { getLeadTimelineApi } from "../../services/leadsApi";

import "./LeadTimeline.css";

const LeadTimeline = () => {
  const { id } = useParams();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user"));

  const fetchTimeline = async () => {
    try {
      const res = await getLeadTimelineApi(id);
      setData(res.data);
    } catch (err) {
      alert(err?.response?.data?.message || "Error loading timeline");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTimeline();
  }, [id]);

  if (loading) return <p style={{ padding: 20 }}>Loading timeline...</p>;

  return (
    <div className="admin-container">

      <Sidebar role={user.role} />

      <div className="admin-main">

        <Navbar />

        <div className="admin-content">

          {/* LEAD HEADER */}
          <div className="timeline-header">
            <h2>📍 {data?.lead?.shop_name}</h2>
            <p>📞 {data?.lead?.phone}</p>
            <p>🏙️ {data?.lead?.city}</p>
            <p>📊 Status: <b>{data?.lead?.status}</b></p>
          </div>

          {/* TIMELINE */}
          <div className="timeline">

            {data?.timeline?.length === 0 && (
              <p>No activity found</p>
            )}

            {data?.timeline?.map((item) => (
              <div key={item.id} className="timeline-item">

                <div className="timeline-box">

                  <h4>{item.title}</h4>

                  <p>{item.description}</p>

                  <small>
                    👤 {item.user?.name} | 🕒{" "}
                    {new Date(item.created_at).toLocaleString()}
                  </small>

                  {/* STATUS CHANGE */}
                  {item.type === "STATUS_CHANGE" && (
                    <p>
                      🔄 {item.status_from} → {item.status_to}
                    </p>
                  )}

                  {/* LOCATION */}
                  {item.location && (
                    <p>📍 {item.location}</p>
                  )}

                  {/* VISIT PROOFS */}
                  {item.proofs?.length > 0 && (
                    <div className="proofs">
                      {item.proofs.map((p) => (
                        <div key={p.id} className="proof-card">
                          <img
                            src={p.image_url}
                            alt="proof"
                          />
                          <p>{p.note}</p>
                        </div>
                      ))}
                    </div>
                  )}

                </div>

              </div>
            ))}

          </div>

        </div>
      </div>
    </div>
  );
};

export default LeadTimeline;